<script>
    import ValidationMessage from './ValidationMessage.svelte'
    import sortApiDataByName from '@legacy/client/module/sortApiDataByName.js'
    import Required from './Required.svelte'
    import { FormGroup, Input, Label } from 'sveltestrap'
    import { createEventDispatcher } from 'svelte'
    import { get } from 'dot-prop'

    import DisableLock from '../fanxLight/DisableLock.svelte'

    export let context
    export let formKey
    export let index
    export let keypath // The keypath without the formKey or index, e.g. "attributes.videos.3.url"
    export let label
    export let options
    export let required
    export let helptext
    export let value
    export let includeDefaultValue
    export let defaultValueText = 'Select one...'
    export let disableSort
    export let disabled

    let selectableOptions

    $: formKeypath = index === undefined ? `${formKey}.${keypath}` : `${formKey}.${index}.${keypath}`
    $: isInvalid = get(context, `error.${formKeypath}.level`) === 'error'
    $: selectable = Array.isArray(options)
        ? options
        : Object.keys(options).map((id) => ({ id: Number(id), name: options[id] }))

    $: {
        const selectable = Array.isArray(options)
            ? options
            : Object.keys(options).map((id) => ({ id: Number(id), name: options[id] }))
        selectableOptions = disableSort ? selectable : sortApiDataByName(selectable)
    }

    const dispatch = createEventDispatcher()
    const update = (event) => {
        dispatch('change', { formKey, index, keypath, value: event.target.value, context })
    }
</script>

<FormGroup>
    <Label for={formKeypath}>
        {label || ''}
        <Required {required} />
    </Label>
    <div 
        class="component-form-field-select"
        on:focus
    >
        <div class="input-container">
            <Input
                type="select"
                id={formKeypath}
                name={formKeypath}
                {isInvalid}
                class="form-select"
                bind:value
                on:change={update}
                on:blur
                disabled={disabled}
            >
                {#if includeDefaultValue}
                    <option value="">{defaultValueText}</option>
                {/if}

                {#each selectableOptions as { id, name }}
                    <option value={id} selected={id === value}>{name}</option>
                {/each}
            </Input>
            {#if disabled}
                <div class="disable-lock">
                    <DisableLock />
                </div>
            {/if}
        </div>       
    </div>
    <ValidationMessage {context} {formKeypath} {helptext} />
</FormGroup>

<style>
    .component-form-field-select{
        position: relative;
        width: 100%
    }

    .input-container {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-evenly;
        align-items: center;
        position: relative;
    }

    .disable-lock {
        position: absolute;
        right: 1.8rem;
        display: flex;
        align-items: center;
    }
</style>